import React, { ReactElement } from "react";
import { GoNote } from "react-icons/go";
import TimeAgo from "react-timeago";
import { TicketMessage } from "../../../__generated__/api";
import Avatar from "../../avatar/Avatar";

interface BodyProps {
    message: TicketMessage;
    className: string;
    attachmentClassName: string;
}
function Body({ message, className, attachmentClassName }: BodyProps): ReactElement {
    return (
        <div>
            {/* eslint-disable-next-line react/no-danger */}
            <div className={className} dangerouslySetInnerHTML={{ __html: message.body.html ?? "" }} />

            {message.attachments?.isNotEmpty && (
                <div className={`d-flex flex-wrap mb-3 flex-grow-1 ${attachmentClassName}`}>
                    {message.attachments?.map(attach => (
                        <a
                            className="col-6 card text-decoration-none"
                            href={attach.url}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img src={attach.url} alt={attach.title as string} className="card-img-top" />
                            <div className="card-body pt-1">
                                <span className="card-text">{attach.title}</span>

                            </div>

                        </a>
                    ))}
                </div>
            )}

        </div>
    );
}

export interface MessageCardProps {
    message: TicketMessage;
}

export default function NoteCard({ message }: MessageCardProps): ReactElement {
    const date = new Date(message.createdDate);

    return (
        <div className="mt-3 d-flex justify-content-end p-1">
            <div className="alert bg-gray-300 border rounded pb-1 overflow-auto">

                <Body className="" message={message} attachmentClassName="" />
                <div className="d-flex flex-rows justify-content-end border-top pt-2">

                    <small className="text-gray me-2">
                        <TimeAgo
                            date={date}
                            minPeriod={60}
                            title={`${date.toLocaleDateString()} ${date.toLocaleTimeString()}`}
                        />
                        {" "}
                        |
                        {" "}
                        {message.creator?.name ?? "Agent"}
                    </small>
                    <Avatar
                        src={message.creator?.avatarUrl as string}
                        variant="xxs"
                        isCircle={false}
                    />
                </div>
            </div>
            <GoNote className="ms-2 text-light" />

        </div>
    );
}
